import React from "react";
import { Button } from "react-bootstrap";
import { Link, useHistory, useLocation } from "react-router-dom";
import TryLogin from "../Components/TryLogin";
import UserContext from "../UserContext";
import Logged from "../Components/Profile.jsx";
import NavbarSearchResult from "../Components/Search/NavbarSearchResult";
import SEO from "../Components/SEO";

function Search() {
  const { user, searchResults, searchHommies } = React.useContext(UserContext);
  const [loading, setloading] = React.useState(false);

  const history = useHistory();
  if (!user.token) {
    history.push("/login");
  }
  const { key, results } = searchResults;
  const location = useLocation();

  React.useEffect(() => {
    setloading(true);
    let search = location.search;
    if (search) {
      search = search.slice(1);
      let values = search.split("&");
      for (let i = 0; i < values.length; i++) {
        if (values[i].split("=")[0] === "key") {
          searchHommies(values[i].split("=")[1]);
          break;
        }
      }
    }
    setloading(false);
  }, [location, searchHommies]);
  return (
    <>
      <SEO title={`Search Hommies`}></SEO>
      <div className="sm:px-5 lg:px-60 pb-12 lg:pb-0">
        <div className="">
          <div className="px-4 lg:px-0 lg:flex w-full gap-10">
            <div className="lg:w-1/2">
              <div className="mt-4">
                {key ? (
                  <div>
                    <div>
                      Search results for <b>{key}:</b>
                      {results.length === 0 ? (
                        <div className="mt-3 mb-5">no results found</div>
                      ) : loading ? (
                        <div className="mt-3 mb-5">Loading...</div>
                      ) : (
                        <div className="mt-3 mb-5">
                          {results.map((result) => (
                            <NavbarSearchResult
                              user={result}
                              key={result._id}
                            ></NavbarSearchResult>
                          ))}
                          <p className="mt-4">
                            {results.length}{" "}
                            {results.length === 1 ? "result" : "results"} found
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                ) : (
                  <div className="mt-5 mb-5 text-center">
                    Enter any text to search
                  </div>
                )}
                <Link to="/" className="readMore__link">
                  <Button className="mb-3 bg-fire hover:opacity-80 text-white rounded px-3 ">
                    Return to Home
                  </Button>
                </Link>
              </div>
            </div>
            <div className="lg:w-1/2">
              {user.token ? <Logged /> : <TryLogin />}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Search;
